var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('alert-dialog',{attrs:{"value":_vm.value,"button-confirm-label":"Sim, desejo enviar"},on:{"input":_vm.closeDialog,"close":_vm.closeDialog,"confirm":_vm.sendProposal}},[_c('p',[_vm._v("Você tem certeza que deseja enviar essa proposta?")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }